var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addapp" },
    [
      _c(
        "el-form",
        {
          ref: "data",
          attrs: {
            model: _vm.data,
            rules: _vm.rulesadd,
            "status-icon": true,
            "show-message": false,
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-right": "8px" },
              attrs: {
                label: "应用名称: ",
                "label-width": _vm.formLabelWidth,
                prop: "name",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "selectWidth",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  on: {
                    focus: function ($event) {
                      return _vm.getFirst()
                    },
                    change: _vm.handleChangeFirst,
                  },
                  model: {
                    value: _vm.data.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "name", $$v)
                    },
                    expression: "data.name",
                  },
                },
                _vm._l(_vm.appNameData, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item.name, value: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.data.name != ""
            ? _c(
                "el-form-item",
                {
                  staticStyle: { "padding-left": "8px" },
                  attrs: {
                    label: "版本号: ",
                    "label-width": _vm.formLabelWidth,
                    prop: "version",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selectWidth",
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      on: {
                        focus: function ($event) {
                          return _vm.getSecond()
                        },
                      },
                      model: {
                        value: _vm.data.version,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "version", $$v)
                        },
                        expression: "data.version",
                      },
                    },
                    _vm._l(_vm.appNameDatas, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item.version, value: item.version },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "中文: ",
                "label-width": _vm.formLabelWidth,
                prop: "cnFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.cnFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "cnFixPoint", $$v)
                  },
                  expression: "data.cnFixPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "英文: ",
                "label-width": _vm.formLabelWidth,
                prop: "enFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.enFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "enFixPoint", $$v)
                  },
                  expression: "data.enFixPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "繁体: ",
                "label-width": _vm.formLabelWidth,
                prop: "hkFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.hkFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "hkFixPoint", $$v)
                  },
                  expression: "data.hkFixPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: {
                label: "日文: ",
                "label-width": _vm.formLabelWidth,
                prop: "jpFixPoint",
              },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.data.jpFixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "jpFixPoint", $$v)
                  },
                  expression: "data.jpFixPoint",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isDisable },
              on: { click: _vm.submit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }